import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import * as _ from "lodash";
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Rx';
import {PointOfSale} from "./point-of-sale";
import {AlfredA2Service} from "../../core/alfred.service";

@Injectable()
export class PointOfSaleServiceA2 {

    private baseUrl: string = '../rest/company/';
    private endpoint:string = '/pointsOfSale';

    constructor(private http : Http, private alfredService: AlfredA2Service) {}

   getData(companyId:number,countryCode:string): any {
        return Observable.forkJoin([this.getKm(), this.getPhoneCode(companyId), this.getMeetingTypes(), this.getPaymentMethods(countryCode)]);
    }

    getKm(): any {
        return this.http
            .get(`../rest/data/kilometerSegmentType`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'kilometerSegment.type.'));
    }

    getPaymentMethods(countryCode:string): any {
        return this.alfredService.getCreditCards(countryCode);
    }

    getPhoneCode(companyId:number): any {
        return this.http
            .get(`../rest/data/phoneCode/${companyId}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    getMeetingTypes(): any {
        return this.http
            .get(`../rest/data/meetingTypes`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'pointOfSale.meetingType.'));
    }

    getHours():string[]{
        return  ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00'];
    }

    getDays():string[]{
        return ['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY','SUNDAY'];
    }

    private mapActions(response:Response, message): string[]{
        let body = response.json();
        return _.map(body, (item) => {return {id:item, value:message+item}}) || [];
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }

    get(companyOid){
        return this.http
            .get(`${this.baseUrl}${companyOid}/pointOfSale`, { headers: this.getHeaders()})
            .map((response) => <PointOfSale[]>response.json());
    }

    getOne(companyOid, id){
        return this.http
            .get(`${this.baseUrl}${companyOid}/pointOfSale/${id}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    save(pos: PointOfSale, companyOid: number) {
        return this.http.post(`${this.baseUrl}${companyOid}/pointOfSale`, pos);
    }

    update(pos: PointOfSale, companyOid: number, id: string) {
        pos.oid=id;
        return this.http.put(`${this.baseUrl}${companyOid}/pointOfSale/${id}`, pos);
    }

    remove(companyOid: number, id: string){
        return this.http.delete(`${this.baseUrl}${companyOid}/pointOfSale/${id}`);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/point-of-sale.service.ts